/**
 * Fast, non-cryptographic hash for auto-save dedupe. Runs in sync — the backend never trusts
 * this value for anything other than "is the content identical to last time I saw it?"
 */
export function fnv1a(input: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}
